export const SEND_TO_WORLD_PAY = gql`
    mutation sendToWorldPay($input: SendToWorldPayInput) {
        sendToWorldPay(input: $input) {
            id
            status
        }
    }
`;
